import { TrendingUp, Users, Award, Target } from 'lucide-react';

const StatsSection = () => {
  const stats = [
    {
      icon: Target,
      value: '100+',
      label: 'Target Organizations',
      description: 'Kenya and beyond',
      color: 'text-primary',
    },
    {
      icon: TrendingUp,
      value: '25-40%',
      label: 'Productivity Increase',
      description: 'within 6 months',
      color: 'text-primary',
    },
    {
      icon: Users,
      value: '35-50%',
      label: 'Employee Satisfaction',
      description: 'improvement',
      color: 'text-success',
    },
    {
      icon: Award,
      value: '40-60%',
      label: 'Leadership Effectiveness',
      description: 'improvement',
      color: 'text-excel',
    },
    
  ];

  return (
    <section className="py-16 md:py-24 bg-gradient-stats">
      <div className="px-2 md:container mx-auto md:px-4">
        <div className="text-center mb-16">
          <h2 className="font-display font-semibold text-3xl md:text-4xl lg:text-5xl mb-6">
            We Don't Just Train – We <span className="text-primary">Transform</span>
          </h2>
          <p className="text-large text-muted-foreground max-w-4xl mx-auto leading-relaxed">
            At <span className="text-blue-600">TCLA-X</span>, we don't just train – we transform. Our comprehensive capacity building programs are 
            designed to elevate individual performance and organizational excellence across Kenya and beyond - our goal for 2025/2026.
          </p>
        </div>

        <div className="grid-stats grid-cols-2 lg:grid-cols-4 sm:grid-cols-1 md:grid-cols-2 gap-2 sm:gap-4 md:gap-6">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="card-elegant text-center group animate-scale-in px-1"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="space-y-1 md:space-y-4">
                <div className={`w-16 h-16 mx-auto rounded-2xl bg-gradient-to-br from-primary/10 to-primary/5 flex items-center justify-center group-hover:shadow-glow transition-all duration-300`}>
                  <stat.icon className={`w-8 h-8 ${stat.color}`} />
                </div>
                
                <div className="space-y-2">
                  <div className={`text-2lg md:text-4xl font-bold font-display ${stat.color}`}>
                    {stat.value}
                  </div>
                  <div className="font-semibold text-foreground">
                    {stat.label}
                  </div>
                  <div className="text-sm text-muted-foreground">
                    {stat.description}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;